import AccessTimeIcon from '@material-ui/icons/AccessTime'
import CompareArrowsIcon from '@material-ui/icons/CompareArrows'
import FlagIcon from '@material-ui/icons/Flag'
import ScheduleIcon from '@material-ui/icons/Schedule'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { Box, Card, CardContent, Grid, Typography, Tooltip } from '@mui/material'

const TotalHoursCard = ({
  userId,
  targetHours,
  targetHoursBonus,
  expectedHours,
  actualHours,
  actualHoursBonus,
  differenceHours,
  differenceBounusHours,
  leavesHours,
  lastUpdatedDate,
  haveData
}) => {
  const username = localStorage.getItem('name')

  const stats = [
    {
      label1: 'Targeti:',
      value1: targetHours != null ? `${targetHours.toFixed(2)}h` : '--',
      label2: `Orët e arritura, (Pushime me pagesë: ${leavesHours != null ? `${leavesHours.toFixed(2)}h` : '--'})`,
      value2: actualHours != null ? `${actualHours.toFixed(2)}h` : '--',
      label3: 'Diferenca',
      value3: differenceHours != null ? `${differenceHours.toFixed(2)}h` : '--',
      icon: <FlagIcon color='primary' fontSize='large' />,
      title: 'Ore Efektive',
      tooltip: 'Informacione për targetet dhe orët e arritura'
    },
    {
      // label1: 'Pushime me pagesë',
      // value1: leavesHours != null ? `${leavesHours.toFixed(2)}h` : '--',
      label1: 'Targeti:',
      value1: targetHoursBonus != null ? `${targetHoursBonus.toFixed(2)}h` : '--',
      label2: `Orët e arritura, (Pushime me pagesë: ${leavesHours != null ? `${leavesHours.toFixed(2)}h` : '--'})`,
      value2: actualHoursBonus != null ? `${actualHoursBonus.toFixed(2)}h` : '--',
      label3: 'Diferenca:',
      value3: differenceBounusHours != null ? `${differenceBounusHours.toFixed(2)}h` : '--',
      icon: <CompareArrowsIcon color={differenceHours != null && differenceHours < 0 ? 'error' : 'info'} fontSize='large' />,
      tooltip: 'Informacione për pushimet dhe diferencat',
      title: 'Ore Bonusi'
    }
  ]

  return (
    <Card sx={{ position: 'relative' }}>
      <CardContent>
        {userId ? (
          <Typography variant='h6'>Orët e përdoruesit</Typography>
        ) : (
          <Typography variant='h6'>Përshëndetje, {username}!</Typography>
        )}

        <Grid container spacing={2} mt={5} alignItems='stretch'>
          {stats.map((stat, index) => (
            <Grid key={index} item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Box
                sx={{
                  position: 'relative', // set relative positioning for absolute tooltip placement
                  width: '100%',
                  minHeight: '200px',
                  p: 2,
                  border: '1px solid #ddd',
                  borderRadius: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  overflow: 'hidden'
                }}
              >
                {/* Added Tooltip */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 10
                  }}
                >
                  <Tooltip title={stat.tooltip} arrow>
                    <InfoOutlinedIcon
                      sx={{
                        fontSize: '1.5rem',
                        color: '#888',
                        cursor: 'pointer'
                      }}
                    />
                  </Tooltip>
                </Box>

                <Box display='flex' alignItems='center' mb={2}>
                  <Box
                    sx={{
                      fontSize: '1rem',
                      mr: 1,
                      color: stat.color
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Typography variant='h6' sx={{ fontSize: '1.2rem' }}>
                    {stat.title}
                  </Typography>
                </Box>
                <Box display='flex' alignItems='center' justifyContent='space-between' mb={2}>
                  <Typography variant='body1' sx={{ fontSize: '1rem' }}>
                    {stat.label1}
                  </Typography>
                  <Typography variant='h5' sx={{ fontSize: '1.4rem' }}>
                    {stat.value1}
                  </Typography>
                </Box>
                <Box display='flex' alignItems='center' justifyContent='space-between' mb={2}>
                  <Typography variant='body1' sx={{ fontSize: '1rem' }}>
                    {stat.label2}
                  </Typography>
                  <Typography variant='h5' sx={{ fontSize: '1.4rem' }}>
                    {stat.value2}
                  </Typography>
                </Box>
                <Box display='flex' alignItems='center' justifyContent='space-between'>
                  <Typography variant='body1' sx={{ fontSize: '1rem' }}>
                    {stat.label3}
                  </Typography>
                  <Typography variant='h5' sx={{ fontSize: '1.4rem' }}>
                    {stat.value3}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
      {haveData && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, p: 2 }}>
          Përditësimi i fundit: {new Date(lastUpdatedDate).toLocaleDateString('en-GB')}
        </Box>
      )}
    </Card>
  )
}

export default TotalHoursCard
